import type {
  EventFeedbackForm,
  ReplaceEventFeedbackFormRequest,
} from '@mds/shared/types/event-feedback';

import {
  errorCode,
  questionSetDraftOf,
  questionSetInputOf,
  type QuestionSetDraft,
} from '@/domain/form-builder';

/** The feedback form being edited: its questions, and whether invitations go out. */
export interface FeedbackDraft extends QuestionSetDraft {
  isEnabled: boolean;
}

/** A new event's feedback form before anyone touches it: nothing sent, no questions of its own. */
export const blankFeedbackDraft = (): FeedbackDraft => ({
  isEnabled: false,
  ungrouped: [],
  sections: [],
});

export const feedbackDraftOf = (form: EventFeedbackForm): FeedbackDraft => ({
  isEnabled: form.isEnabled,
  ...questionSetDraftOf(form),
});

export const replaceRequestOf = (
  draft: FeedbackDraft,
  expectedVersion: number,
): ReplaceEventFeedbackFormRequest => ({
  expectedVersion,
  isEnabled: draft.isEnabled,
  ...questionSetInputOf(draft),
});

/** Someone else saved since this copy was loaded. */
export const FEEDBACK_FORM_CHANGED = 'EVENT_FEEDBACK_FORM_CHANGED';

/** Invitations have gone out, so the form is frozen. */
export const isFormLocked = (error: unknown) => errorCode(error) === 'EVENT_FEEDBACK_FORM_LOCKED';
